// extracted by mini-css-extract-plugin
export default {"splashContainer":"styles_splashContainer__kuf1F","logo":"styles_logo__8UH9p","logoAnimation":"styles_logoAnimation__7A8S2"};